import { initComponent } from './core/init-component.js'

initComponent('.js-style-guide', el => {
  console.log('init style guide', el);

  return {
    unload() {
      console.log('unload', el);
    },
    select() {
      console.log('select', el);
      return () => {
        console.log('deselect', el);
      }
    },
    reorder() {
      console.log('reorder', el);
    },
    selectBlock(block) {
      console.log('selectBlock', block);
      return () => {
        console.log('deselectBlock', block);
      }
    }
  }
});
